<template>
  <v-stepper
    v-model="e6"
    vertical
  >
    <v-stepper-step
      :complete="e6 > 1"
      step="1"
      editable
    >
      상품 정보
      <small
        class="mt-1"
      >
        {{ products.title }}
      </small>
    </v-stepper-step>

    <v-stepper-content step="1">
      <v-card
        color="indigo lighten-5"
        class="pa-1"
      >
        <v-simple-table color="transparent" dense>
          <template v-slot:default>
            <tbody>
              <tr>
                <td>상품 사진</td>
                <td>
                  <v-img
                    :src="products.src"
                    max-width="100"
                  ></v-img>
                </td>
              </tr>
              <tr>
                <td>상품 정보</td>
                <td>{{ products.title }}</td>
              </tr>
              <tr>
                <td>상품 가격</td>
                <td>{{ products.price | currency }} 원</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
      <!-- <v-btn
        color="primary"
        @click="e6 = 2"
      >
        다음
      </v-btn> -->
    </v-stepper-content>

    <v-stepper-step
      :complete="e6 > 2"
      step="2"
      editable
    >
      배송지 정보<font class="caption blue--text">(기타 배송지 입력=>수정요망)</font>
      <small
        class="mt-1"
      >
        {{ form.address + ' ' + form.nextAddress }}
      </small>
    </v-stepper-step>

    <v-stepper-content step="2">
      <v-card
        color="indigo lighten-5"
        class="pa-1"
      >
        <v-card
          color="white"
        >
          <v-form
            ref="form"
            lazy-validation
          >
            <v-text-field
              v-model="form.company"
              label="업체명"
              required
              dense
              class="mt-0 pa-1 pt-5"
              readonly
            ></v-text-field>

            <v-row
              class="mx-0"
            >
              <v-col
                cols="5"
                md="5"
                class="px-1"
              >
              <!-- 수정기능 추가 시 주소찾기 버튼 활성화 20210507 -->
                <v-text-field
                  v-model="form.postcode"
                  label="우편번호"
                  dense
                  v-show="false"
                  @click="isPostCode = !isPostCode"
                ></v-text-field>
              </v-col>

              <v-col
                cols="7"
                md="7"
              >
              <!-- 수정기능 추가 시 주소찾기 버튼 활성화 20210507 -->
                <v-btn
                  @click="isPostCode = !isPostCode"
                  dense
                  class="px-2"
                  v-show="false"
                >
                  우편번호/주소 찾기
                </v-btn>
              </v-col>
            </v-row>
            <v-text-field
              v-model="form.address"
              label="주소"
              dense
              required
              class="pa-1"
              @click="isPostCode = !isPostCode"
            ></v-text-field>

            <v-text-field
              v-model="form.nextAddress"
              label="상세 주소"
              dense
              required
              class="pa-1"
            ></v-text-field>
          </v-form>
        </v-card>
      </v-card>
    </v-stepper-content>

    <v-stepper-step
      :complete="e6 > 3"
      step="3"
      editable
    >
      결제 정보
    </v-stepper-step>

    <v-stepper-content step="3">
      <v-card
        color="indigo lighten-5"
        class="pa-1 mb-12"
      >
        <v-simple-table color="transparent" dense>
          <template v-slot:default>
            <tbody>
              <tr>
                <td>입금 계좌</td>
                <td>
                  국민은행<br />
                  947801-01-412768<br />
                  엔타비글로벌
                </td>
              </tr>
              <tr>
                <td>결제 금액</td>
                <td>
                  {{ paymentPrice | currency }} 원
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
      <v-btn
        color="primary"
        @click="orderProducts"
      >
        주문
      </v-btn>
      <v-btn
        text
        @click="goProducts"
      >
        취소
      </v-btn>
    </v-stepper-content>
  </v-stepper>
</template>

<!-- // For 카카오톡 푸시 -->
<script type="text/javascript" src="https://developers.kakao.com/sdk/js/kakao.mim.js"></script>

<script>
export default {
  data () {
    return {
      e6: 3,
      products: {
        productID: '',
        Quantity: '',
        title: '',
        price: '',
        src: ''
      },
      isPostCode: false,
      form: {
        id: '',
        name: '',
        email: '',
        company: '',
        address: '',
        postcode: '',
        nextAddress: '',
        uName: ''
      },
      paymentPrice: 0
    }
  },

  created () {
    this.subscribe()
  },

  destroyed () {
  },

  updated () {
  },

  mounted () {
  },

  filters: {
    currency (value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },

  methods: {
    subscribe () {
      var _this = this

      var params = _this.$route.params
      var userID = _this.$firebase.auth().currentUser.uid

      var fm = _this.form
      var pdt = _this.products

      _this.$firebase.database().ref('users/' + userID).once('value').then(function (snapshot) {
        fm.id = userID
        fm.name = (snapshot.val() && snapshot.val().displayName) || '승인중'
        fm.email = (snapshot.val() && snapshot.val().email) || ''
        fm.company = (snapshot.val() && snapshot.val().company) || ''
        fm.uName = (snapshot.val() && snapshot.val().displayName) || ''
        // fm.password = (snapshot.val() && snapshot.val().password) || ''
        fm.postcode = (snapshot.val() && snapshot.val().postcode) || ''
        fm.address = (snapshot.val() && snapshot.val().address) || ''
        fm.nextAddress = (snapshot.val() && snapshot.val().nextAddress) || ''
        fm.grade = (snapshot.val() && snapshot.val().grade) || 0
      })

      _this.unsubscribe = _this.$firebase.firestore().collection('products').doc(params.productID).get().then(function (doc) {
        pdt.productID = params.productID
        pdt.Quantity = params.Quantity
        pdt.title = doc.data().title
        pdt.dcFlag = doc.data().dcFlag
        pdt.defPrice = doc.data().price
        pdt.discountPrice_1 = doc.data().discountPrice_1
        pdt.discountPrice_2 = doc.data().discountPrice_2
        pdt.discountPrice_3 = doc.data().discountPrice_3
        if (pdt.dcFlag === 'Y') {
          switch (fm.grade) {
            case 1:
              pdt.price = pdt.discountPrice_1
              break
            case 2:
              pdt.price = pdt.discountPrice_2
              break
            case 3:
              pdt.price = pdt.discountPrice_3
              break
            default:
              pdt.price = pdt.defPrice
              break
          }
        } else if (pdt.dcFlag === 'N') {
          switch (fm.grade) {
            case 1:
              pdt.price = pdt.defPrice
              break
            case 2:
              pdt.price = pdt.defPrice
              break
            case 3:
              pdt.price = pdt.defPrice
              break
            default:
              pdt.price = pdt.defPrice
              break
          }
        }
        pdt.src = doc.data().src
        _this.paymentPrice = params.Quantity * pdt.price
      })
    },

    async orderProducts () {
      var _this = this

      var datetime = new Date()

      var userID = _this.$firebase.auth().currentUser.uid

      var orderData = {
        userID: userID,
        productID: _this.products.productID,
        productTitle: _this.products.title,
        Quantity: _this.products.Quantity,
        company: _this.form.company,
        postcode: _this.form.postcode,
        address: _this.form.address,
        nextAddress: _this.form.nextAddress,
        paymentPrice: _this.paymentPrice,
        orderDate: datetime.toJSON().slice(0, 10).replace(/-/g, '.'),
        orderTime: datetime.getHours() + ':' + datetime.getMinutes() + ':' + datetime.getSeconds()
      }
      // var docId = datetime.toJSON().slice(0, 10).replace(/-/g, '.') + '-' + datetime.getHours() + ':' + datetime.getMinutes() + ':' + datetime.getSeconds() + '-' + _this.form.company
      // var docId = datetime
      // await this.$firebase.firestore().collection('orders').add(orderData).then(
      await this.$firebase.firestore().collection('orders').add(orderData).then(
        function () {
          var company = _this.form.company
          var pTitle = _this.products.title
          var pQty = _this.products.Quantity
          var pPrice = _this.paymentPrice
          var date =  datetime.toJSON().slice(0, 10).replace(/-/g, '.')
          // console.log('Order: ' + _this.form.company + '/' + _this.products.title + '/' + _this.products.Quantity + '/' + _this.paymentPrice + '/' + datetime.toJSON().slice(0, 10).replace(/-/g, '.') + '/' + datetime.getHours() + ':' + datetime.getMinutes() + ':' + datetime.getSeconds())
          console.log('Order2: ' + company + '/' + pTitle + '/' + pQty + '/' + pPrice + '/' + date)
          // _this.kakaoSendTo(_this.form.company,_this.products.title,_this.products.Quantity,_this.paymentPrice,datetime.toJSON().slice(0, 10).replace(/-/g, '.')) // 나에게 카카오 문자보내기
          _this.send_linkCustom()
          _this.kakaoSendTo(company,pTitle,pQty,pPrice,date) // 나에게 카카오 문자보내기
          // _this.kakaoSendToAdmin(company,pTitle,pQty,pPrice,date) // 배송담당자에게 보내기
          // alert('주문 완료')
          _this.goProducts()
        },
        function (error) {
          console.log(error)
        },
      )
    },
    sendLinkCustom() {
        Kakao.init("2d91bae1654af0bf8b3e7b6acbdaf16c");
        Kakao.Link.sendCustom({
            templateId: 579140
        })
    },
    kakaoSendTo(company,pTitle,pQty,pPrice,date) {
      console.log('KakaoMSG: ' + company + '/' + pTitle + '/' + pQty + '/' + pPrice + '/' + date)
    //  거래처에서 주문이 들어오면 카톡에 로그인한 본인에게 톡을 보냄
    // kakaoSendTo(company,pTitle,pQty,pPrice,date) {
      console.log('Order3: ' + company + '/' + pTitle + '/' + pQty + '/' + pPrice + '/' + date)
      Kakao.Auth.login({
      scope: 'PROFILE,TALK_MESSAGE',
      success: function() {
        Kakao.API.request({
          url: '/v2/api/talk/memo/default/send',
          data: {
            template_object: {
              object_type: 'feed',
              content: {
                title: '주문자: ' + company,
                description: '상품:' + pTitle+ ' /수량:' + pQty + ' /가격:' + pPrice + ' /일자:' +date,
                image_url:
                  'https://sell.smartstore.naver.com/shop1.phinf.naver.net/20200709_37/1594220700166X5X7B_JPEG/31580534488373252_1064085629.jpg?type=f154',
                  // '',
                link: {
                  mobile_web_url: 'https://developers.kakao.com',
                  web_url: 'https://developers.kakao.com',
                  // mobile_web_url: '',
                  // web_url: '',
                },
              },
              social: {
                // like_count: 286,
                // comment_count: 45,
                // shared_count: 845,
                like_count: '',
                comment_count: '',
                shared_count: '',
              },
              // buttons: [
              //   {
              //     title: '웹으로 보기',
              //     link: {
              //       mobile_web_url: 'https://developers.kakao.com',
              //       web_url: 'https://developers.kakao.com',
              //     },
              //   }
              //   {
              //     title: '앱으로 보기',
              //     link: {
              //       mobile_web_url: 'https://developers.kakao.com',
              //       web_url: 'https://developers.kakao.com',
              //     },
              //   },
              // ],
              buttons: [
                {
                  title: '',
                  link: {
                    mobile_web_url: '',
                    web_url: '',
                  },
                },
                {
                  title: '',
                  link: {
                    mobile_web_url: '',
                    web_url: '',
                  },
                },
              ],
            },
          },
          success: function(res) {
            //alert('success: ' + JSON.stringify(res))
            alert('주문이 접수되었습니다. 담당자에게 공유해주세요.')
            console.log('OrderRPT: ' + company + '/' + pTitle + '/' + pQty + '/' + pPrice + '/' + date)
          },
          fail: function(err) {
            // alert('error: ' + JSON.stringify(err))
            alert('카카오톡 오류! 담당자에게 확인요청 문자를 보내주세요(010-9075-6799)')
            console.log('ErrorRPT: ' + company + '/' + pTitle + '/' + pQty + '/' + pPrice + '/' + date)
          },
        })
      },
      fail: function(err) {
        alert('failed to login: ' + JSON.stringify(err))
      },
      })
    },
    goProducts () {
      this.$router.replace('Products')
    }
  }
}
</script>
